var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"g-tab"},_vm._l((_vm.tabs),function(e){return _c('span',{key:e.value,staticClass:"tab",class:{ on: _vm.value == e.value },on:{"click":function($event){return _vm.tabFn(e.value)}}},[_vm._v(_vm._s(e.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }